import React, { Component } from 'react';
import './LeftNavigation.css';

class LeftNavigation extends Component {
  constructor(props) {
    super(props)
    this.state = {
      checked: [
        true,
        true,
        true,
        true,
      ]
    }
    this.changeCheckState = this.changeCheckState.bind(this);
  }
  componentWillMount() {

  }
  render() {
    if (!this.props.profile.profile)
      return null;

    else {
      const loyaltyUser = this.props.profile.profile.loyaltyEnrollmentIndicator;
      return (
        <div className='col__12-12'>
          <section class="accordion__wrapper accordion__wrapper--medium accordion__wrapper--noborders">
            {Object.keys(this.props.navigation).map((item, index) => {
              if(item === 'For The Pros')
              {
                if(loyaltyUser === "Y")
                {
                  return this.getNavigationItem(item, index);
                }
              }
              else{
                return this.getNavigationItem(item, index);
              }
            })
            }
          </section>
        </div>
      );
    }
  }
  getNavigationItem(item, index) {
    return (
      <div class="accordion__item">
        <input class="accordion__input" id={'ac-' + index} name={'accordion-' + index} checked={this.state.checked[index]} type="checkbox" onClick={(e) => this.changeCheckState(e, index)} />
        <label class="accordion__label" for={'ac-' + index}>
          <div class="accordion__trigger"><div class="accordion__plus"></div></div>
          {item}
        </label>
        {Object.keys(this.props.navigation[item].links).map((link) => {
          return (
            <div class="accordion__content-wrapper">
              <div class="accordion__content">
                {this.props.navigation[item].links[link].active
                  ?
                  <p>{link}</p>
                  :
                  <a data-automation-id={this.props.navigation[item].links[link].dataAutomationId} class="list__link" href={this.props.navigation[item].links[link].url}>{link}</a>
                }
              </div>
            </div>
          )
        })}
      </div>
    )
  }
  changeCheckState(e, index) {
    let local_state = this.state.checked
    local_state[index] = this.state.checked[index] ? false : true;
    this.setState({
      local_state
    })
  }
}

export default LeftNavigation;



// WEBPACK FOOTER //
// ./src/Components/LeftNavigation/LeftNavigation.js